import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab, Paper, Chip } from '@mui/material';
import {
  LoginOutlined, DashboardOutlined, LaunchOutlined,
  TimelineOutlined, SchoolOutlined, PersonOutlined,
  PhoneIphone as PhoneIcon,
} from '@mui/icons-material';
import IosLoginMockup from './IosLoginMockup';
import IosDashboardMockup from './IosDashboardMockup';
import IosPartnerLaunchMockup from './IosPartnerLaunchMockup';
import IosProgressMockup from './IosProgressMockup';
import IosJoinClassMockup from './IosJoinClassMockup';
import IosProfileMockup from './IosProfileMockup';

const IosMockupIndex = () => {
  const [tab, setTab] = useState(0);
  return (
    <Box sx={{ maxWidth: '100%', mx: 'auto' }}>
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
          <PhoneIcon sx={{ fontSize: 28, color: '#1976d2' }} />
          <Typography variant="h4" fontWeight={700}>
            AchieveDXP iOS Port — UI Mockups
          </Typography>
          <Chip label="MOCKUP" size="small" color="warning" sx={{ fontWeight: 700 }} />
          <Chip label="iPhone 375×812 / HIG" size="small" variant="outlined" />
        </Box>
        <Typography variant="body1" color="text.secondary">
          Six web mockups of the native iOS app wrapping AchieveDXP in WKWebView.
          Follows Apple HIG (large titles, translucent nav, tab bar, SF font stack, iOS blue #007AFF).
          See <code>docs/ACHIEVEDXP_IOS_DESIGN.md</code> for the underlying architecture.
        </Typography>
      </Box>

      <Paper sx={{ mb: 3 }} elevation={1}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ '& .MuiTab-root': { textTransform: 'none', fontWeight: 600, fontSize: '0.9rem', minHeight: 56 } }}
        >
          <Tab icon={<LoginOutlined />}     iconPosition="start" label="1. Login" />
          <Tab icon={<DashboardOutlined />} iconPosition="start" label="2. Dashboard" />
          <Tab icon={<LaunchOutlined />}    iconPosition="start" label="3. Partner Launch" />
          <Tab icon={<TimelineOutlined />}  iconPosition="start" label="4. Progress" />
          <Tab icon={<SchoolOutlined />}    iconPosition="start" label="5. Join Class" />
          <Tab icon={<PersonOutlined />}    iconPosition="start" label="6. Profile" />
        </Tabs>
      </Paper>

      <Box>
        {tab === 0 && <IosLoginMockup />}
        {tab === 1 && <IosDashboardMockup />}
        {tab === 2 && <IosPartnerLaunchMockup />}
        {tab === 3 && <IosProgressMockup />}
        {tab === 4 && <IosJoinClassMockup />}
        {tab === 5 && <IosProfileMockup />}
      </Box>
    </Box>
  );
};

export default IosMockupIndex;
